<template>
  <div class="wrapper-isni" id="isni-form">
    <Header title="ISNI"
            @headerChangesLangTrigger="changeLang"
            v-bind="{
              onAppChangesLang: this.appChangeLangTrigger
            }"
    />
    <Hero />
    <div class="row wrapper-picture_hp hide-on-small-only"></div>
    <main v-if="!loading">
      <div class="container main-wrapper">
        <router-view
            @emailReceiptPageChangesLangTrigger="changeLang"
            v-bind="{
              dataSelect: this.dataSelect,
              textErreur: this.textErreur,
              textFormulaire: this.textFormulaire
            }"
        />
      </div>
    </main>
    <div class="container wrapper-preloader" v-if="loading">
      <div class="row">
        <div class="col s12">
          <div class="center-align preloader">
            <div class="preloader-wrapper big active">
              <div class="spinner-layer spinner-blue-only">
                <div class="circle-clipper left">
                  <div class="circle"></div>
                </div>
                <div class="gap-patch">
                  <div class="circle"></div>
                </div>
                <div class="circle-clipper right">
                  <div class="circle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import M from "materialize-css";
import Header from "@/components/shared/Header";
import Footer from "@/components/shared/Footer";
import Hero from "@/components/shared/Hero";
/** Appel du service REST */
import { getApiService } from "@/services/getApi.service";
import { langService } from "@/services/lang.service";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Hero,
  },
  data() {
    return {
      dataSelect: {},
      textErreur: {},
      textFormulaire: {},
      appChangeLangTrigger: true,
      dataSelectformulaire: [],
      dataTextFormulaire: [],
      loading: false,
      langSelected: "fr"
    };
  },
  methods: {
    async changeLang() {
      // get lang from service
      this.langSelected = langService.getLang();

      // update refs
      await this.getRefTextFormulaire();
      await this.getRefTablesJson();
      await this.setTextErreur();

      // update trigger
      this.appChangeLangTrigger = !this.appChangeLangTrigger;
    },
    /**
     * Appel du service pour recuperer les textes
     */
    async getRefTextFormulaire() {
      this.loading = false;
      try {
        this.textFormulaire = this.langSelected === "en" ?
            this.dataTextFormulaire.data.RefTexteFormulaire[0] :
            this.dataTextFormulaire.data.RefTexteFormulaire[1];
      } catch (e) {
        console.debug("[WARN - App - getRefTextFormulaire] Error : " + e);
      }
    },
    /**
     * Recuperation de la langue pour la gestion des erreurs
     */
    async setTextErreur() {
      // this.dataSelectformulaire.data defines the apropriate this.textFormulaire
      if (this.dataSelectformulaire && this.dataSelectformulaire.data) {
        try {
          this.textErreur = this.langSelected === "en" ? this.textFormulaire["En"] : this.textFormulaire["Fr"];
        } catch (e) {
          console.debug("[WARN - App - setTextErreur] Error : " + e);
        }
      }
    },
    /**
     * Appel du service pour recuperer les options des selects
     */
    async getRefTablesJson() {
      try {
        this.dataSelect = this.dataSelectformulaire.data[this.langSelected];
      } catch (e) {
        console.debug("[WARN - App - getRefTablesJson] Error : " + e);
      }
    },
    async getRefs() {
      this.dataTextFormulaire = await getApiService.getFormText();
      this.dataSelectformulaire = await getApiService.getFormTextSelect();
    },
    async setupRefsData() {
      await this.getRefs();
      await this.getRefTextFormulaire();
      await this.getRefTablesJson();
      await this.setTextErreur();
    }
  },
  created() {
    // appel REST
    this.setupRefsData();
  },
  mounted() {
    M.AutoInit();
  },
  updated() {
    M.AutoInit();
  }
};
</script>
<style lang="scss" scoped>
.main-wrapper {
  margin-bottom: 150px;
}
.wrapper-preloader {
  .preloader {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
